import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, DestroyRef, Inject, OnInit, inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { Roles } from '../../../models';
import { RoleService } from '../../../services';
import { ButtonComponent } from '@shared/components/button/button.component';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgIf } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { InputComponent } from '@shared/components/input/input.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';
import { ToastAlertService } from '@core/index';

@Component({
  selector: 'app-role-create-modal',
  templateUrl: './role-create-modal.component.html',
  standalone: true,
  imports: [
    MatCardModule,
    TitleComponent,
    MatButtonModule,
    MatTooltipModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDialogContent,
    InputComponent,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    MatSelectModule,
    MatOptionModule,
    MatDialogActions,
    ButtonComponent,
    MatDialogClose,
  ],
})
export class RoleCreateModalComponent implements OnInit {
  private formBuilder = inject(FormBuilder);
  roleService = inject(RoleService);
  operation = '';
  roleForm!: FormGroup;
  private destroyRef = inject(DestroyRef);
  private alertService = inject(ToastAlertService);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit(): void {
    if (this.data?.roleid) {
      this.operation = 'Modificar';
      this.roleForm = this.formBuilder.group({
        id: [this.data.roleid],
        name: [this.data.name, Validators.required],
        code: [this.data.rolecode, Validators.required],
        description: [
          this.data.description,
          [Validators.required, Validators.maxLength(256)],
        ],
        type: [this.data.type, Validators.required],
        recurrence: [
          this.data.recurrence,
          [Validators.required, Validators.min(0)],
        ],
      });
    } else {
      this.operation = 'Crear';
      this.roleForm = this.formBuilder.group({
        id: ['0'],
        name: ['', Validators.required],
        code: ['', Validators.required],
        description: ['', [Validators.required, Validators.maxLength(256)]],
        type: ['', Validators.required],
        recurrence: ['', [Validators.required, Validators.min(0)]],
      });
    }
  }

  onChangeInput(input: HTMLInputElement) {
    if (input.valueAsNumber < 0) {
      input.valueAsNumber = 0;
    }
  }

  submit() {
    const obj: Roles = {
      roleid: parseInt(this.roleForm.controls['id'].value, 10),
      name: this.roleForm.controls['name'].value,
      rolecode: this.roleForm.controls['code'].value,
      description: this.roleForm.controls['description'].value,
      type: this.roleForm.controls['type'].value,
      recurrence: this.roleForm.controls['recurrence'].value,
    };
    if (this.data) {
      this.roleService
        .updateRole(obj, this.data.roleid)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: response => {
            if (response.code === 10000) {
              console.log(response);
            } else {
              this.alertService.error(response.detail);
            }
          },
        });
    } else {
      this.roleService
        .storeRole(obj)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: response => {
            if (response.code === 10000) {
            } else {
              this.alertService.error(response.detail);
            }
          },
        });
    }
  }

  clearForm() {
    this.ngOnInit();
  }
}
